import { useTranslation } from "react-i18next";
import {
  FeatureDefinition,
  VehicleRequirement,
} from "../../api/vehicleFeatures";

/** Read-only summary; keep comparison operators, false and zero explicit. */
export function RequirementSummary({
  definitions,
  requirements,
  className = "text-sm text-secondary",
  showLabel = true,
}: {
  definitions: FeatureDefinition[];
  requirements: VehicleRequirement[];
  className?: string;
  showLabel?: boolean;
}) {
  const { t } = useTranslation("workspace");
  if (!requirements.length) return null;
  const labels = requirements.map((r) => {
    const d = definitions.find((d) => d.id === r.attributeId);
    const name = d?.name || r.attributeId;
    if (typeof r.value === "boolean")
      return r.value ? name : `${name}: ${t("features.no")}`;
    if (typeof r.value === "number") {
      const amount = `${t(`features.${r.operator === "eq" ? "exactly" : r.operator}`)} ${r.value}`;
      return d?.unit ? `${name}: ${amount} ${d.unit}` : `${amount} ${name}`;
    }
    const value =
      d?.options.find((option) => option.id === r.value)?.label ||
      String(r.value);
    return `${name}: ${value}`;
  });
  return (
    <p className={className}>
      {showLabel && (
        <>
          <span className="font-medium text-text">
            {t("features.summaryLabel")}:
          </span>{" "}
        </>
      )}
      {labels.join(", ")}
    </p>
  );
}
